import { Typography } from '@mui/material';
import React from 'react';

interface Props {
  children?: React.ReactNode;
  testId?: string;
}

export function Value(props: Props) {
  return <Typography data-testid={props.testId}>{props.children}</Typography>;
}
